import { Box, Grid, IconButton } from "@mui/material"
import { theme } from "src/providers/ThemeProvider"
import { ErrorIcon, GiftIcon, Text } from "src/shared"
import { CustomerDetailModel } from "src/types"

interface PlacehoderItemProps {
  profile?: CustomerDetailModel
}

const PlacehoderItem = ({ profile }: PlacehoderItemProps) => {
  return (
    <Grid
      flexWrap="nowrap"
      container
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item>
        <Grid container alignItems="center" gap={1}>
          <Box alignItems="center" display="flex" gap={1}>
            <GiftIcon />
            <Text
              fontWeight={700}
              sx={{
                [theme.breakpoints.down(480)]: {
                  fontSize: 18,
                  lineHeight: "22px",
                },
              }}
              lineHeight="31.65px"
            >
              Chọn quà tặng
            </Text>
          </Box>
          <Text
            fontSize={16}
            lineHeight="21.1px"
            color={theme.palette.common.black}
            sx={{
              "& > span": {
                color: theme.palette.info.main,
              },
              [theme.breakpoints.down(480)]: {
                fontSize: 14,
                lineHeight: "18px",
              },
            }}
          >
            Bạn đang có <span>{profile?.TemQuantity || 0}</span> tem
          </Text>
        </Grid>
      </Grid>
      <Grid item>
        <IconButton
          sx={{
            padding: 0,
            "&:hover": {
              backgroundColor: "inherit",
            },
          }}
        >
          <ErrorIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default PlacehoderItem
